/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { InfoResult } from '../model/infoResult';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    InfoServiceInterface
} from './info.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class InfoService extends BaseService implements InfoServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * getInfo
     * Service to check general information about the product version and author. &lt;hr&gt;  Requires authorization of any of following types:  * USER_AUTH_BASIC * USER_BEARER_TOKEN * OAUTH_USER_LOGIN_USER_PASSWORD * OAUTH_USER_CLIENT_CREDENTIAL * OAUTH_USER_LOGIN_PRESENTATION * APPLICATION_AUTH_BASIC * APPLICATION_BEARER_TOKEN * OAUTH_APPLICATION_CLIENT_CREDENTIAL  Token subjects allowed:  * AUTHENTICATE_USER * AUTHENTICATE_PASSWORDLESS_USER * AUTHENTICATE_APPLICATION
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfo(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<InfoResult>;
    public getInfo(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<InfoResult>>;
    public getInfo(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<InfoResult>>;
    public getInfo(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (APPLICATION_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        // authentication (APPLICATION_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_BEARER_TOKEN', 'Authorization', localVarHeaders);

        // authentication (OAUTH_APPLICATION_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_APPLICATION_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_LOGIN_PRESENTATION) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_LOGIN_PRESENTATION', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_LOGIN_USER_PASSWORD) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_LOGIN_USER_PASSWORD', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (USER_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('USER_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        // authentication (USER_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('USER_BEARER_TOKEN', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Info`;
        return this.httpClient.request<InfoResult>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
